import { fetchJsonData } from '../../../global/data/service.js'
import {
  getPreviewPath,
  getRelativeServiceBasePath,
} from '../../../global/environments/path.js'
import { showAlertBanner } from '../../AlertBanner/index.js'
import { STATUS_ERROR } from '../../AlertBanner/Constants.js'
import {
  FUND_DETAILS_ERROR_MESSAGE_TEXT,
  ERROR_MESSAGE_TITLE,
} from '../../../spa/components/investmentProducts/helpers/ErrorMessages.js'
import {
  MODEL_PORTFOLIOS,
  MODEL_PORTFOLIOS_PRODUCTS,
  SEPARATELY_MANAGED_ACCOUNTS,
  SEPARATELY_MANAGED_ACCOUNTS_PRODUCTS,
} from '../Helpers/FundTypes.js'
import { isInvestor } from '../../../global/authentication/authentication-manager.js'
import { getFundSubscription } from '../../../spa/components/productDetail/Helper.js'
import { setFundGroupProductTypeAndFundPath } from './FundTypes.js'

/**
 * @deprecated
 */
async function getFundData(cusip) {
  try {
    const fundUrl = `/api/products('${cusip}')`
    return await fetchJsonData(fundUrl)
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getFundContentData(cusip) {
  try {
    const fundUrl =
      getRelativeServiceBasePath() +
      getPreviewPath() +
      `/service/funds/details?cusip=${cusip}`
    return await fetchJsonData(fundUrl)
  } catch (err) {
    console.error(err)
    return null
  }
}

async function getFundApplicationData(cusip, fundCategory) {
  try {
    let fundUrl = `/pnp.svc/getproductdetails?cusip=${cusip}&dataType=FundPortfolio`
    if (fundCategory === MODEL_PORTFOLIOS) {
      fundUrl = `/pnp.svc/getproductdetails?accountID=${cusip}&dataType=${MODEL_PORTFOLIOS_PRODUCTS}`
    } else if (fundCategory === SEPARATELY_MANAGED_ACCOUNTS) {
      fundUrl = `/pnp.svc/getproductdetails?accountID=${cusip}&dataType=${SEPARATELY_MANAGED_ACCOUNTS_PRODUCTS}`
    }

    return await fetchJsonData(fundUrl)
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getProductListByCusip(cusip) {
  try {
    const fundUrl = `/pnp.svc/productList?cusip=${cusip}&groupbycategory=true`
    return await fetchJsonData(fundUrl)
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getProductListByCategory(productType) {
  try {
    const fundUrl = `/pnp.svc/productList?group=${productType}&groupbycategory=true`
    return await fetchJsonData(fundUrl)
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getProductList(productType) {
  try {
    const fundUrl = `/pnp.svc/productList?group=${productType}`
    return await fetchJsonData(fundUrl)
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getFullHoldings(cusip, dataType) {
  try {
    const fundUrl = `/pnp.svc/getproductdetails?cusip=${cusip}&dataType=${dataType}`
    return await fetchJsonData(fundUrl)
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getHistoricalData(cusip) {
  try {
    const fundUrl = `/pnp.svc/historicalData?cusip=${cusip}`
    return await fetchJsonData(fundUrl)
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getGrowth10kData(cusip) {
  try {
    const fundUrl = `/pnp.svc/performanceGrowth?cusip=${cusip}`
    return await fetchJsonData(fundUrl)
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getCapGainsDistReports(cusip) {
  try {
    const fundUrl = `/pnp.svc/capitalGains?cusip=${cusip}`
    return await fetchJsonData(fundUrl)
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getSubscriptionDataByFundName(fundNames) {
  const retreivedFunds = await getFundSubscription()

  try {
    const foundFunds = []

    if (retreivedFunds?.funds?.length > 0) {
      fundNames.map((fund) => {
        retreivedFunds.funds.map((fundData) => {
          if (fundData.name === fund.fundName || fundData.name === fund) {
            foundFunds.push(fundData)
          }
        })
      })
    }
    return foundFunds
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getSubscriptionDataByProductType(docType) {
  const retreivedFunds = await getFundSubscription()

  try {
    return (
      retreivedFunds?.funds?.filter((fund) => fund.productType === docType) ||
      []
    )
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getFundSubscriptionDataByCusip(cusip) {
  try {
    const funds = await getFundSubscription()
    return funds?.funds?.reduce(
      (p, n) => (n?.cusip?.includes(cusip) ? n : p),
      {}
    )
  } catch (err) {
    console.error(err)
    showAlertBanner({
      status: STATUS_ERROR,
      title: ERROR_MESSAGE_TITLE,
      text: FUND_DETAILS_ERROR_MESSAGE_TEXT,
    })
  }
}

async function getFund(cusip) {
  const fundContent = await getFundContentData(cusip)
  const fundApplicationData = await getFundApplicationData(
    cusip,
    fundContent?.fundCategory
  )

  const _fund = bindFundData(fundContent, fundApplicationData)

  // exposing for Interaction Studio
  globalThis.CTIFund = _fund
  return _fund
}

const getDocByName = (literatureList, docTitle) => {
  if (literatureList?.value) {
    const factSheet = literatureList.value.find(
      (litDoc) => litDoc.docTitle === docTitle
    )
    return factSheet?.docURL
  }
  return null
}

function bindFundData(fundContent, fundApplicationData) {
  let _fund =
    (fundApplicationData.value &&
      fundApplicationData.value.productDetail && {
        ...fundApplicationData.value.productDetail,
      }) ||
    {}

  if (fundContent) {
    _fund = {
      ..._fund,
      ...fundContent,
    }
  }

  const literatureConvertUrlToInvestor = (documentsArray) => {
    documentsArray.forEach((doc) => {
      const url = doc?.docURL
      if (url?.startsWith('/') && !url.toLowerCase().includes('.pdf')) {
        doc.docURL = `/investor${url}`
      }
    })
  }

  const noteWorthyConvertToInvestor = (section, index, arr) => {
    const normalized = section?.toLowerCase()

    if (normalized?.includes('href="/') && !normalized.includes('.pdf')) {
      arr[index] = section.replaceAll('href="/', 'href="/investor/')
    }
  }

  // Update relative links to point to correct site
  if (isInvestor()) {
    // New & Noteworthy
    if (_fund.newNoteWorthy) {
      const splitString = _fund.newNoteWorthy.split('<a')

      splitString.forEach(noteWorthyConvertToInvestor)

      _fund.newNoteWorthy = splitString.join('<a')
    }

    //fund literature
    if (_fund.literature) {
      if (_fund?.literature?.productDocuments?.value) {
        literatureConvertUrlToInvestor(_fund.literature.productDocuments.value)
      }

      if (_fund?.literature?.regulatoryDocuments?.value) {
        literatureConvertUrlToInvestor(
          _fund?.literature?.regulatoryDocuments?.value
        )
      }
    }

    // 529 Underlying Funds
    if (_fund?.underlyingFunds?.underLyingFundsDetails) {
      const underLyingFundsDetailsSplit =
        _fund.underlyingFunds.underLyingFundsDetails.split('href="/')

      _fund.underlyingFunds.underLyingFundsDetails =
        underLyingFundsDetailsSplit.join('href="/investor/')
    }
  }

  _fund.miscellaneousDetails = {
    layoutID: fundApplicationData?.value?.productDetail?.layoutID,
    fundGroup: fundApplicationData?.value?.productDetail?.fundGroup,
  }

  if (_fund?.fundMaintenance?.mergerFund) {
    _fund.messageContents = _fund.messageContents || {}
    _fund.messageContents.mergerFund = _fund.fundMaintenance.mergerFund
    _fund.fundName = _fund.name
  }

  if (_fund?.fundMaintenance?.renameFund) {
    _fund.messageContents = _fund.messageContents || {}
    _fund.messageContents.renameFund = _fund.fundMaintenance.renameFund
    _fund.fundName = _fund.name
  }

  if (_fund?.fundMaintenance?.productNews) {
    _fund.messageContents = _fund.messageContents || {}
    _fund.messageContents.productNews = _fund.fundMaintenance.productNews
    _fund.fundName = _fund.name
  }

  _fund.fundHeader = {
    fundName: _fund.fundName || _fund.name,
    symbol: _fund.symbol,
    fundClass: _fund.className,
    classes: {
      value: _fund.classes,
    },
    investorGoals: {
      value: _fund.investorGoals,
    },
    mStarRiskVsCtg: _fund.mStarRiskVsCtg,
    mStarOverallRating: _fund.mStarOverallRating,
    mStarCategory: _fund.mStarCategory,
    mStarRatingAsOfDt: _fund.mStarRatingAsOfDt,
    investCatg: _fund.investCatg,
    fundFactsURL:
      _fund.literature &&
      getDocByName(_fund.literature.productDocuments, 'Fact Sheet'),
    prospectusURL:
      _fund.literature &&
      getDocByName(_fund.literature.regulatoryDocuments, 'Prospectus'),
    attrReportURL:
      _fund.literature &&
      getDocByName(
        _fund.literature.productDocuments,
        'Attribution/Contribution'
      ),
    subCtgValue: _fund.subCtgValue,
    multiManager: _fund.multimanager === 'true',
  }

  if (_fund.minimumInvestment) {
    _fund.summary = _fund.summary || {}
    _fund.summary.fundBasicDetail = _fund.summary.fundBasicDetail || {}
    _fund.summary.fundBasicDetail.minimumInvestment = _fund.minimumInvestment
  }

  if (_fund.subsequentInvestment) {
    _fund.summary = _fund.summary || {}
    _fund.summary.fundBasicDetail = _fund.summary.fundBasicDetail || {}
    _fund.summary.fundBasicDetail.subsequentInvestment =
      _fund.subsequentInvestment
  }

  if (
    _fund.portfolioHighlights &&
    _fund.portfolioHighlights.initialInvestment
  ) {
    _fund.summary = _fund.summary || {}
    _fund.summary.fundBasicDetail = _fund.summary.fundBasicDetail || {}
    _fund.summary.fundBasicDetail.initialInvestment =
      _fund.portfolioHighlights.initialInvestment
  }

  if (
    _fund.fundSummary &&
    _fund.fundSummary.distributions &&
    _fund.fundSummary.distributions.distrSchedule
  ) {
    _fund.summary = _fund.summary || {}
    _fund.summary.distributionsDetail = _fund.summary.distributionsDetail || {}
    _fund.summary.distributionsDetail.distrSchedule =
      _fund.fundSummary.distributions.distrSchedule
  }

  if (_fund.topHoldingDetail) {
    _fund.topHoldingDetail.topHoldingsDisclosure = _fund.topHoldingsDisclosure
  }

  if (_fund.risk) {
    _fund.risk = {
      ..._fund.risk,
      ..._fund.riskDetail,
    }
  }

  setFundGroupProductTypeAndFundPath(_fund)

  return _fund
}

const flattenFunds = (data) =>
  (data?.value?.products ?? []).flatMap((product) => product?.funds ?? [])

export {
  getFundData,
  getProductListByCusip,
  getProductListByCategory,
  getProductList,
  getFullHoldings,
  getHistoricalData,
  getGrowth10kData,
  getCapGainsDistReports,
  getSubscriptionDataByFundName,
  getSubscriptionDataByProductType,
  getFundSubscriptionDataByCusip,
  getFundApplicationData,
  getFundContentData,
  getFund,
  bindFundData,
  flattenFunds,
  getDocByName,
}

export { getDistributionReports } from '../../../spa/components/productDetail/Helper.js'
